(function () {
  'use strict';

  function slideStep(track) {
    var first = track.firstElementChild;
    if (!first) return track.clientWidth * 0.8;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  /* Dots mode: for fade/class-based carousels the arrows simply advance the
     existing dot pagination (data-carousel-dots holds the dots' selector). */
  function initDotsMode(group, scope) {
    var dotsSelector = group.getAttribute('data-carousel-dots');
    var prev = group.querySelector('[data-carousel-prev]');
    var next = group.querySelector('[data-carousel-next]');

    function dots() {
      return Array.prototype.slice.call(scope.querySelectorAll(dotsSelector));
    }

    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) {
        if (
          list[i].getAttribute('aria-selected') === 'true' ||
          list[i].getAttribute('aria-current') === 'true' ||
          /--active(\s|$)/.test(list[i].className)
        ) {
          return i;
        }
      }
      return 0;
    }

    function update() {
      var list = dots();
      var index = activeIndex(list);
      group.hidden = list.length < 2;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= list.length - 1;
    }

    function go(delta) {
      var list = dots();
      var target = list[activeIndex(list) + delta];
      if (target) target.click();
      window.setTimeout(update, 50);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var observer = new MutationObserver(update);
    dots().forEach(function (dot) {
      observer.observe(dot, { attributes: true, attributeFilter: ['class', 'aria-selected', 'aria-current'] });
    });

    group.dataset.carouselArrowsInit = 'true';
    update();
  }

  function initArrows(group) {
    if (group.dataset.carouselArrowsInit === 'true') return;

    var scope = group.closest('section, .shopify-section') || document;

    if (group.hasAttribute('data-carousel-dots')) {
      initDotsMode(group, scope);
      return;
    }

    var selector = group.getAttribute('data-carousel-target');
    if (!selector) return;

    var track = scope.querySelector(selector);
    if (!track) return;

    var prev = group.querySelector('[data-carousel-prev]');
    var next = group.querySelector('[data-carousel-next]');

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var noOverflow = maxScroll <= 1;
      group.hidden = noOverflow;
      if (prev) prev.disabled = noOverflow || track.scrollLeft <= 1;
      if (next) next.disabled = noOverflow || track.scrollLeft >= maxScroll - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -slideStep(track), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: slideStep(track), behavior: 'smooth' });
      });
    }

    var scrollRaf = null;
    track.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = null;
          update();
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', update);

    group.dataset.carouselArrowsInit = 'true';
    update();
  }

  function initAll(root) {
    var groups = (root || document).querySelectorAll('[data-carousel-arrows]');
    Array.prototype.forEach.call(groups, initArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
